//爱博医疗
import Overview from '@rebuild/materials/shared/question/Overview.vue';
import Full from '@rebuild/materials/shared/question/FullIndex.vue';
import MobFull from '@rebuild/materials/shared/question/mobile/MobFullIndex.vue';
import MobOverview from '@rebuild/materials/shared/question/mobile/MobOverview.vue';
import MobDetail from '@rebuild/materials/shared/question/mobile/MobDetail.vue';

import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/question/context';

function useSelfContext() {
    provideCurrentContext({
        questionTabList: [
            {
                label: '上证e互动',
                value: 3
            }
        ]
    });
}

export const componentMap = {
	overview: Overview,
	full: withProvider(Full, useSelfContext),
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 